// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/weeks-with-games-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventWeeksWithGamesListBody,
  typeEventWeeksWithGamesListOutput200,
} from "../../sdk/event/postEventWeeksWithGamesList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventWeeksWithGamesListQueryKey(
  payload: typeEventWeeksWithGamesListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  return [
    "post:event:eventWeeksWithGamesList",
    "svc:events-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventWeeksWithGamesListOutput200,
    unknown,
    typeEventWeeksWithGamesListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventWeeksWithGamesList(
  payload: typeEventWeeksWithGamesListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventWeeksWithGamesListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventWeeksWithGamesList(payload),
    ...resolvedOptions,
  });
}
